function Informacion() {
  return (
    <div>
      <h1>Informacion</h1>
    </div>
  )
}

export default Informacion;